module.exports = __webpack_public_path__ + "static/media/heavy_mist.100faf06.svg";